var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal new-modal",
      "height": "auto",
      "name": "patternMaker",
      "width": "92%",
      "maxWidth": _vm.maxWidth,
      "scrollable": true,
      "clickToClose": false
    },
    on: {
      "beforeOpen": _vm.beforeOpenModal,
      "closed": _vm.closeModal
    }
  }, [_c('PatternMakerView')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }